import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import socket from '../../socket';
import useSocketEvent from '../../utils/useSocketEvent';

const DEFAULT_TEXT = 'Um mitzuspielen, ruft auf eurem eigenen Handy oder Laptop diese Adresse auf und meldet euch dort mit eurem Namen an.';

// Wird gezeigt, wenn /show ohne aktive Spieler-Session aufgerufen wird
// (z.B. auf einem Gemeinschaftsbildschirm/Beamer). Erklaert Zuschauern,
// wie sie mit ihrem eigenen Geraet mitspielen koennen. Text + Link sind vom
// Moderator im Dashboard (Optionen) editierbar, siehe viewerInfo:setText.
// Ohne konfigurierten Link wird automatisch die eigene Adresse verwendet
// (window.location.origin), das entspricht pro Umgebung automatisch
// test.besserwisser-quiz.de bzw. besserwisser-quiz.de.
function ViewerJoinInfo() {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const [text, setText] = useState(DEFAULT_TEXT);
    const [link, setLink] = useState('');

    useEffect(() => {
        socket.emit('viewerInfo:getConfig', (config) => {
            if (config?.text) setText(config.text);
            setLink(config?.link || '');
        });
    }, []);

    useSocketEvent(socket, 'viewerInfo:update', (config) => {
        if (config?.text) setText(config.text);
        setLink(config?.link || '');
    });

    const displayLink = link || origin;

    return (
        <div className="auth-page">
            <div className="quiz-title-wrap">
                <h1 className="quiz-title neon-title">Besserwisser ?</h1>
            </div>
            <div className="viewer-join-info">
                <p>{text}</p>
                <p className="viewer-join-info-url">{displayLink || 'die Adresse dieser Seite'}</p>
            </div>
            {displayLink && (
                <div className="viewer-join-info-qr">
                    <QRCodeSVG value={displayLink} size={160} bgColor="#ffffff" fgColor="#0b0f1a" />
                </div>
            )}
        </div>
    );
}

export default ViewerJoinInfo;
